
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { global } from "../../Context/Context";
import axios from "axios";
import { toast } from "react-toastify";
import $ from "jquery";
import axiosInstance from "../../config/axiosInterceptor";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ViewUser = () => {
  // ...all your states, hooks, logic unchanged...
  // (Don't touch any logic, as you requested)
  // (No lines removed from your original, only styling below)

  // Copy all your states and handlers from your code above (to stay complete)
  const baseUrl = process.env.REACT_APP_BASEURL1;
  const baseUrl2 = process.env.REACT_APP_BASEURL2;
  const baseUrl5 = process.env.REACT_APP_BASEURL5;
  const [userData, setUserData] = useState("");
  const [coinH, setCoinH] = useState([]);
  const [userDetails, setUserDetails] = useState({});
  const [sign, setSign] = useState({ plus: true, minus: false });
  const [tag, setTag] = useState([]);
  const [Bd, setBd] = useState("");
  const [type, setType] = useState(1);
  const { viewTagg, viewTag, viewadminframes, viewadminentryEffects } =
    useContext(global);

  const [readOnly, setReadOnly] = useState(true);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [isLoading, setIsLoading] = useState();
  const prevIdRef = useRef();
  const prevBaseUrlRef = useRef();
  const isMountedRef = useRef(true);
  const [p, setP] = useState(1);
  const [imageFile, setImageFile] = useState(null); // New state for image
  const [broadBanType, setBroadBanType] = useState(null);
  
  // Username History States
  const [showUsernameHistory, setShowUsernameHistory] = useState(false);
  const [usernameHistory, setUsernameHistory] = useState([]);
  const [usernameHistoryLoading, setUsernameHistoryLoading] = useState(false);

  // IP History States
  const [showIpHistory, setShowIpHistory] = useState(false);
  const [ipHistory, setIpHistory] = useState([]);
  const [ipHistoryLoading, setIpHistoryLoading] = useState(false);

  // Video Wallet States
  const [showVideoWallet, setShowVideoWallet] = useState(false);
  const [vwProfile, setVwProfile] = useState(null);
  const [vwProfileLoading, setVwProfileLoading] = useState(false);
  const [vwHistory, setVwHistory] = useState([]);
  const [vwHistoryLoading, setVwHistoryLoading] = useState(false);
  const [vwPage, setVwPage] = useState(1);
  const [vwTotalPages, setVwTotalPages] = useState(1);
  const [vwTypeFilter, setVwTypeFilter] = useState("");
  const [vwProfileDay, setVwProfileDay] = useState(() => new Date().toISOString().split("T")[0]);

    // Watch Time Enable Toggle
  const [watchTimeEnabled, setWatchTimeEnabled] = useState(false);
  const [watchTimeLoading, setWatchTimeLoading] = useState(false);

  // Fetch watch time enable status
  const fetchWatchTimeEnable = async () => {
    if (!id) return;
    setWatchTimeLoading(true);
    try {
      const res = await axiosInstance.get(`/admin/watchTimeEnable/get?userId=${id}`);
      if (res.data.success === 1) {
        // If data is missing or enabled is undefined, default to true
        if (!res.data.data || typeof res.data.data.enabled === 'undefined') {
          setWatchTimeEnabled(true);
        } else {
          setWatchTimeEnabled(!!res.data.data.enabled);
        }
      } else {
        setWatchTimeEnabled(true);
      }
    } catch (e) {
      setWatchTimeEnabled(true);
    } finally {
      setWatchTimeLoading(false);
    }
  };

  // Update watch time enable status
  const updateWatchTimeEnable = async (enabled) => {
    setWatchTimeLoading(true);
    try {
      const res = await axiosInstance.post(`/admin/watchTimeEnable/set`, { userId: id, enabled });
      if (res.data.success === 1) {
        setWatchTimeEnabled(res.data.data.enabled);
        toast.success(`Watch time eligibility ${enabled ? 'enabled' : 'disabled'}`);
      } else {
        toast.error('Failed to update watch time eligibility');
      }
    } catch (e) {
      toast.error('Failed to update watch time eligibility');
    } finally {
      setWatchTimeLoading(false);
    }
  };
  const toggleReadOnly = () => {
    setReadOnly(!readOnly);
    setUserDetails({
      name: userData?.name,
      gender: userData?.gender,
      bd: userData?.bd,
      agency: userData?.agency,
      agencyAdmin: userData?.agencyAdmin,
      bio: userData?.bio,
      coinTime: userData?.coinTime,
      coinAmount: userData?.coinAmount,
      email: userData?.email
    });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      // Validate email format if email is being updated
      if (userDetails.email && userDetails.email.trim()) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(userDetails.email.trim())) {
          toast.error("Please provide a valid email address");
          return;
        }
      }

      const formData = new FormData();
      formData.append("userDetails", JSON.stringify(userDetails)); // Add user details
      if (imageFile) {
        formData.append("profileImage", imageFile); // Add image file if present
      }
      const response = await axiosInstance.put(
        `${process.env.REACT_APP_BASEURL3}/admin/edituser?id=${id}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" }, // Important for file upload
        }
      );
      if (response.data.success == "1") {
        fetchData();
        toast.success(response.data.message);
        toggleReadOnly();
      } else {
        fetchData();
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error updating user data:", error);
      toast.error(error.message);
    }
  };
  const handlechange = (e) => {
    setUserDetails({ ...userDetails, [e.target.name]: e.target.value });
  };

  const settag = async (tag) => {
    if (tag !== null) {
      try {
        let { data } = await axiosInstance.post(`${baseUrl}/admin/usertag?id=${id}`, { myTag: tag });
        if (data.success == "1") {
          toast.success("Tag updated")
        }
      } catch (error) {
        toast.error(error.message)
        console.error("Error updating user tag:", error);
      }
    }
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setUserData({ ...userData, picture: URL.createObjectURL(file) });
    }
  };
  const updateUserBanStatus = async (banStatusValue) => {
    try {
      const val = { ...userData, status: banStatusValue };
      const d = await axiosInstance.post(
        `${process.env.REACT_APP_BASEURL3}/admin/userban?id=${id}&banStatus=${banStatusValue}`,
        val
      );
      if (d.data.success == "1") {
        toast.success("Successfully Done");
        fetchData();
      }
    } catch (error) {
      toast.error(error.message)
      console.error("Error updating user ban status:", error);
    }
  };
  const updateGameBanStatus = async (status) => {
    try {
      const val = { ...userData, gameStatus: status };
      await axiosInstance.post(`${process.env.REACT_APP_BASEURL5}/admin/gameUserBan?id=${id}&status=${status}`, val).then((res) => {
        if (res.data.success == 1) {
          toast.success(res.data.message);
          fetchData();
        } else {
          toast.error(res.data.message)
        }
      })
    } catch (error) {
      toast.error(error.message)
    }
  }
  const updateGameDeviceBanStatus = async (status) => {
    await axiosInstance.post(`${process.env.REACT_APP_BASEURL5}/admin/deviceGameBan?id=${id}&status=${status}`, userData).then((res) => {
      if (res.data.success == 1) {
        toast.success(res.data.message);
        fetchData();
      } else {
        toast.error(res.data.message)
      }
    }).catch((error) => {
      toast.error(error.message)
    })
  }
  const updateVideoBanStatus = async (status) => {
    try {
      const response = await axiosInstance.post(`${process.env.REACT_APP_BASEURL3}/admin/videoBanStatus?id=${id}&status=${status}`);
      if (response.data.success == 1) {
        toast.success(response.data.message);
        fetchData(); // Refresh user data to get updated status
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  }
  const removeProfilePhoto = async () => {
    if (!window.confirm("Are you sure you want to remove this user's profile photo? This cannot be undone.")) return;
    try {
      const response = await axiosInstance.post(`${process.env.REACT_APP_BASEURL3}/admin/removeProfilePhoto?id=${id}`);
      if (response.data.success === 1) {
        toast.success("Profile photo removed successfully");
        fetchData();
      } else {
        toast.error(response.data.message || "Failed to remove photo");
      }
    } catch (err) {
      toast.error("Error removing photo");
    }
  };
  const updateProfilePhotoBanStatus = async (status) => {
    try {
      const response = await axiosInstance.post(`${process.env.REACT_APP_BASEURL3}/admin/profilePhotoBanStatus?id=${id}&status=${status}`);
      if (response.data.success == 1) {
        toast.success(response.data.message);
        fetchData();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  }
  const toggleEmailVerification = async () => {
    try {
      const newStatus = userData?.verifiedEmail ? "0" : "1";
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_BASEURL3}/admin/toggleEmailVerification?id=${id}&status=${newStatus}`
      );
      if (response.data.success == 1) {
        toast.success(response.data.message);
        fetchData(); // Refresh user data to get updated status
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  }
  const updateUserBanDeviceStatus = async (banStatusValue) => {
    try {
      const val = { ...userData, banStatus: banStatusValue };
      const d = await axiosInstance.post(
        `${process.env.REACT_APP_BASEURL3}/admin/userbanDeviceId?id=${id}&status=${banStatusValue}`,
        val
      );
      if (d.data.success == "1") {
        toast.success(d.data.message);
        fetchData();
      } else {
        toast.error(d.data.message);
      }
    } catch (error) {
      toast.error(error.message)
      console.error("Error updating user ban status:", error);
    }
  };
  const bdname = async () => {
    try {
      await axiosInstance.get(`${baseUrl}/admin/host/findbd?id=${id}`);
    } catch (error) {
      console.error("Error fetch:", error);
    }
  };
  const CoinsTransaction = async (pg, type) => {
    try {
      setCoinH("");
      setSign({ plus: "-", minus: "+" });
      const data1 = await axiosInstance.get(
        `${baseUrl2}/admin/coinHistory?id=${id}&page=${pg}&type=${type}`
      );
      if (data1.data.success === 1) {
        setCoinH(data1.data.details);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  const RecCoinsTransaction = async (pg, type) => {
    try {
      setCoinH("");
      setSign({ plus: "+", minus: "-" });
      const data1 = await axiosInstance.get(
        `${baseUrl2}/admin/recCoinHistory?id=${id}&page=${pg}&type=${type}`
      );
      if (data1.data.success === 1) {
        setCoinH(data1.data.details);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  const ConvertTransactions = async (pg) => {
    try {
      const data1 = await axiosInstance.get(
        `${baseUrl2}/admin/convertTransactions?userId=${id}&page=${pg}`
      );
      if (data1.data.success === 1) {
        setCoinH(data1.data.details);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  
  const fetchUsernameHistory = async () => {
    setUsernameHistoryLoading(true);
    try {
      const response = await axiosInstance.get(
        `/admin/usernameHistory/getUsernameHistoryByUserId?userId=${id}`
      );
      if (response.data.success === 1) {
        setUsernameHistory(response.data.data);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setUsernameHistoryLoading(false);
    }
  };

  const fetchIpHistory = async () => {
    setIpHistoryLoading(true);
    try {
      const response = await axiosInstance.get(
        `/admin/userIpHistory/getUserIpHistoryByUserId?userId=${id}`
      );
      if (response.data.success === 1) {
        setIpHistory(response.data.history);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIpHistoryLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  const fetchVideoWalletProfile = async (day) => {
    setVwProfileLoading(true);
    try {
      const dayParam = day || vwProfileDay;
      const res = await axiosInstance.get(
        `/admin/withdrawal/videoWallet/userProfile?userId=${id}&day=${dayParam}`
      );
      if (res.data.success === "1") {
        setVwProfile(res.data.data);
      } else {
        toast.error(res.data.message);
      }
    } catch (e) {
      toast.error(e.message);
    } finally {
      setVwProfileLoading(false);
    }
  };

  const fetchVideoWalletHistory = async (page = 1, typeF = "") => {
    setVwHistoryLoading(true);
    try {
      const res = await axiosInstance.get(
        `/admin/withdrawal/videoWallet/userHistory?userId=${id}&page=${page}&limit=15${typeF ? `&type=${typeF}` : ""}`
      );
      if (res.data.success === "1") {
        setVwHistory(res.data.history || []);
        setVwTotalPages(res.data.totalPages || 1);
        setVwPage(res.data.page || 1);
      } else {
        toast.error(res.data.message);
      }
    } catch (e) {
      toast.error(e.message);
    } finally {
      setVwHistoryLoading(false);
    }
  };
  
  const fetchData = async () => {
    try {
      const data1 = await axiosInstance.get(
        `${process.env.REACT_APP_BASEURL3}/admin/view_user?id=${id}`
      );
      if (isMountedRef.current && data1.data.success === 1) {
        setUserData(data1.data.details);
        setUserDetails(data1.data.details);
        toast.success(data1.data.message)
        const banStatusValue = data1.data.details.banStatus;
        $("#o-tagggg").val(banStatusValue);
      }
    } catch (error) {
      toast.error(error.message)
      console.error("Error fetching user data:", error);
    }
  };

  const broadBanUnban = async (userId, type) => {
    try {
      const { data } = await axiosInstance.post(
        `${baseUrl5}/admin/broadBanUnban?userId=${userId}&type=${type}`
      );
      if (data.success == 1) {
        toast.success(data.message);
        fetchData();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error(error.message)
    }
  };

  useEffect(() => {
    fetchData();
    fetchWatchTimeEnable();
    return () => { isMountedRef.current = false; };
  }, []);
  // ...existing code...
  // --- Watch Time Toggle UI ---
  // Place this in your render section where you want the toggle to appear (e.g., near user info or wallet section)
  // Example below:

  useEffect(() => {
    viewTagg();
    viewadminframes();
    viewadminentryEffects();
  }, []);

  const createdAtDate = userData?.createdAt
    ? new Date(userData.createdAt)
    : null;
  const formattedDate = createdAtDate
    ? createdAtDate.toISOString().split("T")[0]
    : "";

  // --- INLINE STYLES ---
  const pageStyles = {
    table: {
      width: "100%",
      borderCollapse: "separate",
      borderSpacing: "0",
      margin: "40px 0 20px 0",
      boxShadow: "0 6px 32px #1677ff13",
      borderRadius: "16px",
      overflow: "hidden",
      background: "#fff"
    },
    th: {
      background: "#f5f7fa",
      color: "#334",
      fontWeight: 700,
      fontSize: 17,
      padding: "14px 12px",
      borderBottom: "2px solid #f0f5ff"
    },
    td: {
      padding: "13px 12px",
      fontSize: 16,
      color: "#222",
      background: "#fff",
      borderBottom: "1px solid #f0f5ff"
    },
    evenRow: {
      background: "#fafcff",
      transition: "background 0.18s"
    },
    oddRow: {
      background: "#fff",
      transition: "background 0.18s"
    },
    btn: {
      background: "linear-gradient(90deg, #007bff 0%, #52c41a 100%)",
      color: "#fff",
      border: "none",
      borderRadius: 8,
      fontWeight: 600,
      fontSize: 16,
      padding: "7px 30px",
      boxShadow: "0 2px 8px #007bff25",
      margin: "0 8px 10px 0",
      cursor: "pointer",
      transition: "background .18s"
    },
    btnSecondary: {
      background: "#fff",
      color: "#1677ff",
      border: "1.2px solid #1677ff",
      boxShadow: "none"
    },
    actionBtn: {
      background: "#f0f5ff",
      color: "#1677ff",
      border: "1.2px solid #1677ff",
      borderRadius: "8px",
      fontWeight: 600,
      fontSize: 16,
      padding: "5px 18px",
      margin: "0 3px",
      cursor: "pointer"
    },
    formLabel: {
      color: "#888",
      fontWeight: 700,
      fontSize: 15
    },
    input: {
      fontSize: 16,
      padding: "8px 13px",
      borderRadius: 7,
      border: "1.5px solid #eee",
      width: "100%"
    },
    fieldBlock: {
      padding: "0 6px 18px 6px"
    },
    profileImg: {
      width: 88,
      height: 88,
      borderRadius: "50%",
      boxShadow: "0 4px 24px #1677ff33",
      objectFit: "cover",
      border: "3px solid #fff",
      display: "block"
    }
  };

  // --- RENDER ---
  return (
    <>
      {userData == "" ? (
        <>Loading</>
      ) : (
        <>
          <section className="content-header">
            <h1 style={{ fontWeight: 700, fontSize: 32, color: "#234" }}>View User</h1>
            <ol className="breadcrumb" style={{ background: "none", marginBottom: 0 }}>
              <li>
                <Link to="/admin" style={{ color: "#1677ff" }}>
                  <i className="fa fa-dashboard"></i> Home
                </Link>
              </li>
              <li>
                <Link to="/admin/manageUser" style={{ color: "#1677ff" }}>
                  <i className="fa fa-user"></i> User
                </Link>
              </li>
              <li className="active" style={{ color: "#888" }}>View User</li>
            </ol>
          </section>

          <section className="content">
            <div style={{ marginBottom: 18 }}>
              <label style={{ fontWeight: 600, fontSize: 16, marginRight: 12 }}>Watch Time Eligibility</label>
              <input
                type="checkbox"
                checked={watchTimeEnabled}
                disabled={watchTimeLoading}
                onChange={e => updateWatchTimeEnable(e.target.checked)}
                style={{ width: 22, height: 22, verticalAlign: 'middle', marginRight: 8 }}
              />
              <span style={{ color: watchTimeEnabled ? '#52c41a' : '#ff4d4f', fontWeight: 600 }}>
                {watchTimeEnabled ? 'Enabled' : 'Disabled'}
              </span>
              {watchTimeLoading && <span style={{ marginLeft: 10, color: '#888' }}>Updating...</span>}
            </div>
            <div className="row" style={{ display: "flex", justifyContent: "center" }}>
              <div className="col-md-10 col-12" style={{ borderRadius: 22, background: "#fff", boxShadow: "0 8px 40px #1677ff18", padding: 0, overflow: "hidden" }}>
                {/* Animated CSS injected once */}
                <style>{`
                  @keyframes vu-fadein { from { opacity: 0; transform: translateY(18px); } to { opacity: 1; transform: translateY(0); } }
                  @keyframes vu-avatarpop { 0% { transform: scale(0.7); opacity: 0; } 70% { transform: scale(1.07); } 100% { transform: scale(1); opacity: 1; } }
                  @keyframes vu-badgepulse { 0%,100% { box-shadow: 0 0 0 0 #faad1455; } 60% { box-shadow: 0 0 0 7px #faad1400; } }
                  @keyframes vu-shine {
                    0% { background-position: -200% center; }
                    100% { background-position: 200% center; }
                  }
                  @keyframes vu-banshake { 0%,100%{transform:translateX(0)} 20%{transform:translateX(-3px)} 40%{transform:translateX(3px)} 60%{transform:translateX(-2px)} 80%{transform:translateX(2px)} }
                  .vu-profile-header { animation: vu-fadein 0.55s cubic-bezier(.22,1,.36,1) both; }
                  .vu-avatar-wrap { animation: vu-avatarpop 0.6s cubic-bezier(.22,1,.36,1) 0.1s both; }
                  .vu-level-badge { animation: vu-badgepulse 2.5s ease-in-out infinite; }
                  .vu-username { animation: vu-fadein 0.5s 0.2s both; }
                  .vu-ban-badge { animation: vu-banshake 0.6s 0.8s both; }
                  .vu-meta { animation: vu-fadein 0.5s 0.35s both; }
                  .vu-family { animation: vu-fadein 0.5s 0.45s both; }
                  .vu-edit-btn:hover { transform: scale(1.15) rotate(-8deg) !important; box-shadow: 0 4px 16px #007bff55 !important; }
                  .vu-del-btn:hover { transform: scale(1.15) rotate(8deg) !important; box-shadow: 0 4px 16px #ff4d4f66 !important; }
                  .vu-edit-btn, .vu-del-btn { transition: transform 0.2s, box-shadow 0.2s !important; }
                  .vu-vip-badge { background: linear-gradient(90deg, #ffe58f 0%, #faad14 50%, #ffe58f 100%); background-size: 200% auto; animation: vu-shine 2.5s linear infinite; }
                `}</style>

                {/* Gradient banner */}
                <div style={{
                  background: "linear-gradient(135deg, #1677ff 0%, #722ed1 60%, #eb2f96 100%)",
                  height: 90,
                  position: "relative",
                  overflow: "hidden"
                }}>
                  <div style={{
                    position: "absolute", inset: 0,
                    background: "radial-gradient(ellipse at 30% 60%, #ffffff22 0%, transparent 70%)"
                  }} />
                  {/* Floating decorative circles */}
                  <div style={{ position: "absolute", top: -18, right: 60, width: 80, height: 80, borderRadius: "50%", background: "#ffffff12" }} />
                  <div style={{ position: "absolute", top: 10, right: 20, width: 40, height: 40, borderRadius: "50%", background: "#ffffff0e" }} />
                  <div style={{ position: "absolute", bottom: -20, left: 120, width: 60, height: 60, borderRadius: "50%", background: "#ffffff10" }} />
                </div>

                <div style={{ padding: "0 32px 28px 32px" }}>
                  <form
                    role="form"
                    method="post"
                    id="specialitiesForm"
                    encType="multipart/form-data"
                    style={{ marginBottom: 0 }}
                  >
                    {/* Profile header row — pulled up to overlap banner */}
                    <div className="vu-profile-header" style={{ display: "flex", gap: 24, alignItems: "flex-end", marginTop: -50, marginBottom: 20 }}>
                      {/* Avatar */}
                      <div className="vu-avatar-wrap" style={{ position: "relative", flexShrink: 0 }}>
                        {/* Frame overlay */}
                        {userData?.adminFrame?.image && (
                          <img
                            src={userData.adminFrame.image}
                            alt="frame"
                            style={{ position: "absolute", top: -7, left: -7, width: 104, height: 104, zIndex: 2, pointerEvents: "none" }}
                          />
                        )}
                        <div style={{
                          width: 90, height: 90,
                          borderRadius: "50%",
                          background: "linear-gradient(135deg,#1677ff,#722ed1)",
                          padding: 3,
                          boxShadow: "0 8px 32px #1677ff44"
                        }}>
                          <img
                            src={`${baseUrl}${userData?.picture}`}
                            style={pageStyles.profileImg}
                            id="pro_img"
                            alt="profile"
                          />
                        </div>
                        <input type="file" id="image-upload" style={{ display: "none" }} accept="image/*" onChange={handleImageChange} />
                        <button
                          type="button"
                          className="vu-edit-btn"
                          onClick={() => document.getElementById("image-upload").click()}
                          style={{
                            position: "absolute", top: 0, right: -4,
                            background: "linear-gradient(135deg,#007bff,#52c41a)",
                            border: "2px solid #fff", borderRadius: "50%",
                            color: "#fff", fontSize: 13, width: 28, height: 28,
                            display: "flex", alignItems: "center", justifyContent: "center",
                            cursor: "pointer", zIndex: 3
                          }}
                          aria-label="Edit photo"
                        >
                          <i className="fa-solid fa-pen-to-square" />
                        </button>
                        <button
                          type="button"
                          className="vu-del-btn"
                          onClick={removeProfilePhoto}
                          title="Remove profile photo"
                          style={{
                            position: "absolute", bottom: 0, right: -4,
                            background: "linear-gradient(135deg,#ff4d4f,#cf1322)",
                            border: "2px solid #fff", borderRadius: "50%",
                            color: "#fff", fontSize: 11, width: 26, height: 26,
                            display: "flex", alignItems: "center", justifyContent: "center",
                            cursor: "pointer", zIndex: 3
                          }}
                          aria-label="Remove photo"
                        >
                          <i className="fa-solid fa-trash" />
                        </button>
                      </div>

                      {/* Identity info */}
                      <div style={{ flex: 1, paddingBottom: 4 }}>
                        {/* Username row */}
                        <div className="vu-username" style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 7, marginBottom: 8 }}>
                          <span style={{ fontSize: 24, fontWeight: 800, color: "#1a1a2e", letterSpacing: "-0.5px" }}>{userData?.username}</span>

                          {/* Tag image */}
                          {userData?.adminTag?.image && (
                            <img src={userData.adminTag.image} alt="tag" style={{ height: 24, borderRadius: 5, boxShadow: "0 2px 8px #0002" }} />
                          )}

                          {/* Level badge */}
                          <span className="vu-level-badge" style={{
                            fontSize: 12, fontWeight: 800, color: "#fff",
                            background: "linear-gradient(90deg,#faad14,#ff7a00)",
                            padding: "3px 11px", borderRadius: 20,
                            boxShadow: "0 2px 8px #faad1455"
                          }}>Lv.{userData?.level || 0}</span>

                          {/* VIP */}
                          {userData?.myVipDetails?.title && (
                            <span className="vu-vip-badge" style={{
                              display: "inline-flex", alignItems: "center", gap: 4,
                              padding: "3px 10px", borderRadius: 20,
                              border: "1px solid #ffd666",
                              color: "#7d4e00", fontWeight: 800, fontSize: 12,
                              boxShadow: "0 2px 8px #faad1433"
                            }}>
                              {userData.myVipDetails.image && <img src={userData.myVipDetails.image} alt="vip" style={{ height: 16 }} />}
                              {userData.myVipDetails.title}
                            </span>
                          )}
                        </div>

                        {/* Ban badges */}
                        <div className="vu-ban-badge" style={{ display: "flex", flexWrap: "wrap", gap: 5, marginBottom: 8 }}>
                          {userData.banStatus == 1 && <span style={{ background: "linear-gradient(90deg,#ff4d4f,#cf1322)", color: "#fff", fontWeight: 700, fontSize: 11, borderRadius: 20, padding: "2px 10px", boxShadow: "0 2px 8px #ff4d4f44" }}>🚫 Banned</span>}
                          {userData.isBroadBan == "1" && <span style={{ background: "linear-gradient(90deg,#ff7875,#ff4d4f)", color: "#fff", fontWeight: 700, fontSize: 11, borderRadius: 20, padding: "2px 10px", boxShadow: "0 2px 6px #ff4d4f33" }}>📡 Broad Ban</span>}
                          {userData.videoBan == "1" && <span style={{ background: "linear-gradient(90deg,#ffa940,#d46b08)", color: "#fff", fontWeight: 700, fontSize: 11, borderRadius: 20, padding: "2px 10px", boxShadow: "0 2px 6px #ffa94044" }}>🎬 Video Ban</span>}
                          {userData.profilePhotoBan == "1" && <span style={{ background: "linear-gradient(90deg,#b37feb,#722ed1)", color: "#fff", fontWeight: 700, fontSize: 11, borderRadius: 20, padding: "2px 10px", boxShadow: "0 2px 6px #722ed133" }}>📷 Photo Ban</span>}
                          {userData.gameBanStatus == "1" && <span style={{ background: "linear-gradient(90deg,#40a9ff,#0958d9)", color: "#fff", fontWeight: 700, fontSize: 11, borderRadius: 20, padding: "2px 10px", boxShadow: "0 2px 6px #1677ff33" }}>🎮 Game Ban</span>}
                          {userData.isDeviceBanned == "1" && <span style={{ background: "linear-gradient(90deg,#ff7875,#820014)", color: "#fff", fontWeight: 700, fontSize: 11, borderRadius: 20, padding: "2px 10px", boxShadow: "0 2px 6px #82001444" }}>📱 Device Ban</span>}
                        </div>

                        {/* Meta row: Frame + Family */}
                        <div className="vu-meta" style={{ display: "flex", flexWrap: "wrap", gap: 10, alignItems: "center" }}>
                          {userData?.adminFrame?.title && (
                            <div style={{
                              display: "inline-flex", alignItems: "center", gap: 6,
                              background: "#f0f5ff", borderRadius: 20, padding: "4px 12px",
                              border: "1px solid #adc6ff"
                            }}>
                              <i className="fa-regular fa-image" style={{ color: "#1677ff", fontSize: 13 }} />
                              <span style={{ fontSize: 13, color: "#2f54eb", fontWeight: 600 }}>{userData.adminFrame.title}</span>
                            </div>
                          )}
                          {userData?.familyInfo && (
                            <div className="vu-family" style={{
                              display: "inline-flex", alignItems: "center", gap: 7,
                              background: userData.familyInfo.role === "Leader"
                                ? "linear-gradient(90deg,#fff7e6,#ffe7ba)"
                                : userData.familyInfo.role === "Co-leader"
                                ? "linear-gradient(90deg,#f0f5ff,#d6e4ff)"
                                : "linear-gradient(90deg,#f6ffed,#d9f7be)",
                              borderRadius: 20, padding: "4px 14px 4px 8px",
                              border: userData.familyInfo.role === "Leader"
                                ? "1px solid #ffd591"
                                : userData.familyInfo.role === "Co-leader"
                                ? "1px solid #adc6ff"
                                : "1px solid #b7eb8f",
                              boxShadow: "0 2px 8px #0001"
                            }}>
                              {userData.familyInfo.image
                                ? <img src={`${baseUrl}${userData.familyInfo.image}`} alt="family" style={{ height: 22, width: 22, borderRadius: "50%", objectFit: "cover", border: "2px solid #fff", boxShadow: "0 1px 4px #0002" }} />
                                : <span style={{ fontSize: 16 }}>👨‍👩‍👧</span>
                              }
                              <span style={{
                                fontSize: 13, fontWeight: 700,
                                color: userData.familyInfo.role === "Leader" ? "#d46b08"
                                  : userData.familyInfo.role === "Co-leader" ? "#2f54eb" : "#389e0d"
                              }}>{userData.familyInfo.name}</span>
                              <span style={{
                                fontSize: 11, fontWeight: 800, borderRadius: 12, padding: "1px 8px",
                                background: userData.familyInfo.role === "Leader" ? "#d46b08"
                                  : userData.familyInfo.role === "Co-leader" ? "#2f54eb" : "#389e0d",
                                color: "#fff"
                              }}>{userData.familyInfo.role}</span>
                            </div>
                          )}
                        </div>

                        {/* Bio */}
                        {userData.bio && userData.bio !== "" && (
                          <div style={{ fontSize: 14, color: "#666", marginTop: 8, fontStyle: "italic", maxWidth: 420 }}>
                            "{userData.bio}"
                          </div>
                        )}
                      </div>
                    </div>

                  <div className="box-body" style={{ margin: "8px 0 0 0" }}>
                    <div className="row">
                      {[
                        ["Username*", "username", userData?.username, "text", readOnly],
                        ["Name*", "name", userData?.name, "text", readOnly],
                        ["Bio*", "bio", userData?.bio, "text", readOnly],
                        ["Gender*", "gender", userData?.gender, "text", readOnly],
                        ["Number*", "number", userData?.number, "text", readOnly],
                        ["Level*", "level", userData?.level, "text", readOnly],
                        ["Stars*", "coin", userData?.coin, "text", readOnly],
                        ["M-Coins*", "recievingCoins", userData?.recievingCoins, "number", readOnly],
                        ["Coin Time in minutes", "coinTime", userData?.coinTime, "number", readOnly],
                        ["Coin Amount", "coinAmount", userData?.coinAmount, "number", readOnly],
                        ["Email*", "email", userData?.email, "email", readOnly],
                        ["Join Date*", "", formattedDate, "text", true],
                        ["Videos*", "", userData?.videos, "text", true],
                        ["Password", "password", userData?.password, "text", readOnly],
                        ["BD Code", "bd", userData?.bd, "text", readOnly],
                        ["BD Name", "bdname", userData?.bdName, "text", true],
                        ["AgencyAdmin Code", "agencyAdmin", userData?.agencyAdmin, "text", readOnly],
                        ["AgencyAdmin Name", "aaname", userData?.agencyAdminName, "text", true],
                        ["Agency Code", "agency", userData?.agency, "text", readOnly],
                        ["Agency Name", "agencyname", userData?.agencyName, "text", true],
                        ["Followers*", "", userData?.following, "text", true],
                        ["Following*", "", userData?.follow, "text", true]
                      ].map(([label, name, value, type, isReadOnly], idx) => {
                        // Special handling for email field with verification status
                        if (name === "email") {
                          return (
                            <div className="col-sm-6" style={pageStyles.fieldBlock} key={idx}>
                              <div className="form-group">
                                <label style={pageStyles.formLabel}>
                                  {label}
                                  <span style={{
                                    marginLeft: 10,
                                    padding: "2px 8px",
                                    borderRadius: 4,
                                    fontSize: 12,
                                    fontWeight: 600,
                                    background: userData?.verifiedEmail ? "#f6ffed" : "#fff2f0",
                                    color: userData?.verifiedEmail ? "#52c41a" : "#ff4d4f",
                                    border: `1px solid ${userData?.verifiedEmail ? "#52c41a" : "#ff4d4f"}`
                                  }}>
                                    {userData?.verifiedEmail ? "Verified" : "Not Verified"}
                                  </span>
                                </label>
                                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                  <input
                                    type={type}
                                    name={name}
                                    className="form-control"
                                    style={{ ...pageStyles.input, flex: 1 }}
                                    defaultValue={value}
                                    onChange={handlechange}
                                    readOnly={isReadOnly}
                                  />
                                  {!readOnly && (
                                    <button
                                      type="button"
                                      onClick={toggleEmailVerification}
                                      style={{
                                        padding: "6px 12px",
                                        borderRadius: 6,
                                        border: "none",
                                        fontSize: 12,
                                        fontWeight: 600,
                                        cursor: "pointer",
                                        background: userData?.verifiedEmail ? "#ff7875" : "#95de64",
                                        color: "#fff"
                                      }}
                                    >
                                      {userData?.verifiedEmail ? "Unverify" : "Verify"}
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        }
                        
                        // Default field rendering for other fields
                        return (
                          <div className="col-sm-6" style={pageStyles.fieldBlock} key={idx}>
                            <div className="form-group">
                              <label style={pageStyles.formLabel}>{label}</label>
                              <input
                                type={type}
                                name={name}
                                className="form-control"
                                style={pageStyles.input}
                                defaultValue={value}
                                onChange={handlechange}
                                readOnly={isReadOnly}
                              />
                            </div>
                          </div>
                        );
                      })}
                      {/* Official Tag */}
                      <div className="col-md-6" style={pageStyles.fieldBlock}>
                        <div className="form-group">
                          <label htmlFor="o-tag" style={pageStyles.formLabel}>
                            Official Tags
                          </label>
                          <select
                            className="form-control"
                            name="status"
                            id="o-tag"
                            style={{ ...pageStyles.input, border: "1.6px solid #ef5d84" }}
                            onChange={(e) => {
                              const selectedTagId = e.target.value;
                              setTag(selectedTagId);
                              settag(selectedTagId);
                            }}
                          >
                            <option disabled selected>
                              Select Tag
                            </option>
                            {Array.isArray(viewTag) &&
                              viewTag.map((item) => (
                                <option value={item._id} key={item._id}>{item.title}</option>
                              ))}
                          </select>
                        </div>
                      </div>
                      {/* UserId(Ban/ Unban) */}
                      <div className="col-md-6" style={pageStyles.fieldBlock}>
                        <div className="form-group">
                          <label htmlFor="o-tagggg" style={pageStyles.formLabel}>
                            UserId(Ban/ Unban)
                          </label>
                          <select
                            className="form-control"
                            name="status"
                            id="o-tagggg"
                            style={{ ...pageStyles.input, border: "1.6px solid #ef5d84" }}
                            value={userData?.banStatus === "1" ? "1" : "0"}
                            onChange={(e) => updateUserBanStatus(e.target.value)}
                          >
                            <option value="0">Unbanned</option>
                            <option value="1">Banned</option>
                          </select>
                        </div>
                      </div>
                      {/* Broad ban */}
                      <div className="col-md-6" style={pageStyles.fieldBlock}>
                        <div className="form-group">
                          <label htmlFor="broad-ban" style={pageStyles.formLabel}>
                            Broad(Ban/ Unban)
                          </label>
                          <select
                            className="form-control"
                            name="status"
                            id="broad-ban"
                            style={{ ...pageStyles.input, border: "1.6px solid #ef5d84" }}
                            value={userData?.isBroadBan === "1" ? "1" : "0"}
                            onChange={(e) => broadBanUnban(id, e.target.value)}
                          >
                            <option value="0">Broad Unbanned</option>
                            <option value="1">Broad Banned</option>
                          </select>
                        </div>
                      </div>
                      {/* Device Id(Ban/ Unban) */}
                      <div className="col-md-6" style={pageStyles.fieldBlock}>
                        <div className="form-group">
                          <label htmlFor="o-tagdiv" style={pageStyles.formLabel}>
                            Device Id(Ban/ Unban)
                          </label>
                          <select
                            className="form-control"
                            name="status"
                            id="o-tagdiv"
                            style={{ ...pageStyles.input, border: "1.6px solid #ef5d84" }}
                            value={userData?.isDeviceBanned === "1" ? "1" : "0"}
                            onChange={(e) => updateUserBanDeviceStatus(e.target.value)}
                          >
                            <option value="0">Device Id Not Banned</option>
                            <option value="1">Device Id Banned</option>
                          </select>
                        </div>
                      </div>
                      {/* Game user id ban */}
                      <div className="col-md-6" style={pageStyles.fieldBlock}>
                        <div className="form-group">
                          <label htmlFor="game-ban" style={pageStyles.formLabel}>
                            Game UserId(Ban/ Unban)
                          </label>
                          <select
                            className="form-control"
                            name="gameStatus"
                            id="game-ban"
                            style={{ ...pageStyles.input, border: "1.6px solid #ef5d84" }}
                            value={userData?.gameBanStatus === "1" ? "1" : "0"}
                            onChange={(e) => updateGameBanStatus(e.target.value)}
                          >
                            <option value="0">Unbanned</option>
                            <option value="1">Banned</option>
                          </select>
                        </div>
                      </div>
                      {/* Game device id ban */}
                      <div className="col-md-6" style={pageStyles.fieldBlock}>
                        <div className="form-group">
                          <label htmlFor="game-device-ban" style={pageStyles.formLabel}>
                            Game Device Id(Ban/ Unban)
                          </label>
                          <select
                            className="form-control"
                            name="GameDeviceStatus"
                            id="game-device-ban"
                            style={{ ...pageStyles.input, border: "1.6px solid #ef5d84" }}
                            value={userData?.gameBanStatus === "1" ? "1" : "0"}
                            onChange={(e) => updateGameDeviceBanStatus(e.target.value)}
                          >
                            <option value="0">Device Id Not Banned</option>
                            <option value="1">Device Id Banned</option>
                          </select>
                        </div>
                      </div>
                      {/* Video ban */}
                      <div className="col-md-6" style={pageStyles.fieldBlock}>
                        <div className="form-group">
                          <label htmlFor="video-ban" style={pageStyles.formLabel}>
                            Video Upload(Ban/ Unban)
                          </label>
                          <select
                            className="form-control"
                            name="videoBanStatus"
                            id="video-ban"
                            style={{ ...pageStyles.input, border: "1.6px solid #ef5d84" }}
                            onChange={(e) => {
                              const selectedBanStatus = e.target.value;
                              updateVideoBanStatus(selectedBanStatus);
                            }}
                          >
                            <option
                              value={0}
                              selected={userDetails?.videoBan === "0" || userDetails?.videoBan === "" || !userDetails?.videoBan}
                            >
                              Video Upload Allowed
                            </option>
                            <option
                              value={1}
                              selected={userDetails?.videoBan === "1"}
                            >
                              Video Upload Banned
                            </option>
                          </select>
                        </div>
                      </div>
                      {/* Profile Photo ban */}
                      <div className="col-md-6" style={pageStyles.fieldBlock}>
                        <div className="form-group">
                          <label htmlFor="profile-photo-ban" style={pageStyles.formLabel}>
                            Profile Photo Upload(Ban/ Unban)
                          </label>
                          <select
                            className="form-control"
                            name="profilePhotoBanStatus"
                            id="profile-photo-ban"
                            style={{ ...pageStyles.input, border: "1.6px solid #ef5d84" }}
                            value={userData?.profilePhotoBan === "1" ? "1" : "0"}
                            onChange={(e) => updateProfilePhotoBanStatus(e.target.value)}
                          >
                            <option value="0">Profile Photo Allowed</option>
                            <option value="1">Profile Photo Banned</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group" style={{ marginTop: 12 }}>
                    <div style={{ display: "flex", gap: 18, marginLeft: 20 }}>
                      <button
                        type="button"
                        style={pageStyles.btn}
                        onClick={toggleReadOnly}
                      >
                        {readOnly ? "Edit Profile" : "Cancel"}
                      </button>
                      {!readOnly ? (
                        <button
                          type="submit"
                          style={pageStyles.btn}
                          onClick={(e) => {
                            toggleReadOnly();
                            handleFormSubmit(e);
                          }}
                        >
                          Save Changes
                        </button>
                      ) : null}
                    </div>
                  </div>
                  </form>
                </div>
              </div>
            </div>
          </section>

          {/* --- History buttons --- */}
          <div className="d-flex" style={{ margin: "50px 0 20px 0", gap: 24, justifyContent: "center", flexWrap: "wrap" }}>
            <button type="button" style={pageStyles.btn} onClick={() => { setType(1); RecCoinsTransaction(1, 1); setShowUsernameHistory(false); setShowVideoWallet(false); setShowIpHistory(false); }}>Star History</button>
            <button type="button" style={pageStyles.btn} onClick={() => { setType(1); CoinsTransaction(1, 1); setShowUsernameHistory(false); setShowVideoWallet(false); setShowIpHistory(false); }}>M-Coins History</button>
            <button type="button" style={pageStyles.btn} onClick={() => { setType(0); RecCoinsTransaction(1, 0); setShowUsernameHistory(false); setShowVideoWallet(false); setShowIpHistory(false); }}>Recharge</button>
            <button type="button" style={pageStyles.btn} onClick={() => { setType(0); CoinsTransaction(1, 0); setShowUsernameHistory(false); setShowVideoWallet(false); setShowIpHistory(false); }}>Withdrawal</button>
            <button type="button" style={pageStyles.btn} onClick={() => { setType(100); ConvertTransactions(1); setShowUsernameHistory(false); setShowVideoWallet(false); setShowIpHistory(false); }}>Exchange</button>
            <button type="button" style={pageStyles.btn} onClick={() => { setType(2); RecCoinsTransaction(1, 2); setShowUsernameHistory(false); setShowVideoWallet(false); setShowIpHistory(false); }}>Games</button>
            <button type="button" style={pageStyles.btn} onClick={() => { setShowUsernameHistory(true); setShowVideoWallet(false); setShowIpHistory(false); fetchUsernameHistory(); }}>Username History</button>
            <button type="button" style={{ ...pageStyles.btn, background: "linear-gradient(135deg, #6f42c1, #a855f7)" }} onClick={() => { const d = new Date().toISOString().split("T")[0]; setVwProfileDay(d); setShowVideoWallet(true); setShowUsernameHistory(false); setShowIpHistory(false); fetchVideoWalletProfile(d); fetchVideoWalletHistory(1, ""); }}>Video Wallet</button>
            <button type="button" style={{ ...pageStyles.btn, background: "linear-gradient(135deg, #0ea5e9, #06b6d4)" }} onClick={() => { setShowIpHistory(true); setShowUsernameHistory(false); setShowVideoWallet(false); fetchIpHistory(); }}>IP History</button>
          </div>

          {/* --- Username History Section --- */}
          {showUsernameHistory && (
            <div className="container" style={{ padding: 0 }}>
              <section className="content">
                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                  <div className="col-md-10 col-12" style={{ 
                    background: "#fff", 
                    borderRadius: 12, 
                    padding: 30, 
                    boxShadow: "0 4px 18px #1677ff0a",
                    marginBottom: 40
                  }}>
                    <div style={{ 
                      fontSize: 24, 
                      fontWeight: 700, 
                      color: "#1677ff", 
                      marginBottom: 20, 
                      display: "flex", 
                      alignItems: "center", 
                      gap: 12 
                    }}>
                      <i className="fa fa-history"></i>
                      Username Change History
                    </div>

                    {usernameHistoryLoading ? (
                      <div style={{ textAlign: "center", padding: 50 }}>
                        <i className="fa fa-spinner fa-spin" style={{ fontSize: 40, color: "#1677ff" }}></i>
                        <div style={{ marginTop: 10, color: "#888" }}>Loading username history...</div>
                      </div>
                    ) : !usernameHistory || !usernameHistory.history ? (
                      <div style={{ textAlign: "center", padding: 50, color: "#888", fontSize: 16 }}>
                        No history data available
                      </div>
                    ) : (
                      <>
                        <div style={{
                          background: "#f8f9fa",
                          padding: 20,
                          borderRadius: 10,
                          marginBottom: 25,
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center"
                        }}>
                          <div>
                            <div style={{ fontSize: 14, color: "#666", marginBottom: 5 }}>Current Username</div>
                            <div style={{ fontSize: 20, fontWeight: 700, color: "#1677ff" }}>
                              {usernameHistory.currentUsername}
                            </div>
                          </div>
                          <div style={{ textAlign: "right" }}>
                            <div style={{ fontSize: 14, color: "#666", marginBottom: 5 }}>Total Changes</div>
                            <div style={{ fontSize: 24, fontWeight: 700, color: "#52c41a" }}>
                              {usernameHistory.totalChanges}
                            </div>
                          </div>
                        </div>

                        {usernameHistory.history.length === 0 ? (
                          <div style={{ textAlign: "center", padding: 50, color: "#888", fontSize: 16 }}>
                            <i className="fa fa-info-circle" style={{ fontSize: 30, marginBottom: 10 }}></i>
                            <div>No username changes recorded for this user.</div>
                          </div>
                        ) : (
                          <div style={{ position: "relative", paddingLeft: 45 }}>
                            {usernameHistory.history.map((item, index) => (
                              <div 
                                key={item._id} 
                                style={{
                                  position: "relative",
                                  marginBottom: 30,
                                  paddingBottom: 20,
                                  borderLeft: "2px solid #e0e0e0"
                                }}
                              >
                                <div style={{
                                  position: "absolute",
                                  left: -13,
                                  width: 26,
                                  height: 26,
                                  background: "#1677ff",
                                  color: "#fff",
                                  borderRadius: "50%",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontSize: 13,
                                  fontWeight: 700,
                                  boxShadow: "0 2px 8px #1677ff44"
                                }}>
                                  {index + 1}
                                </div>
                                <div style={{ paddingLeft: 25 }}>
                                  <div style={{ 
                                    fontSize: 14, 
                                    color: "#6c757d", 
                                    marginBottom: 10, 
                                    fontWeight: 600 
                                  }}>
                                    <i className="fa fa-calendar"></i> {formatDate(item.changedAt)}
                                  </div>
                                  <div style={{ 
                                    display: "flex", 
                                    alignItems: "center", 
                                    gap: 12, 
                                    fontSize: 16 
                                  }}>
                                    <span style={{
                                      color: "#ff4d4f",
                                      fontWeight: 600,
                                      background: "#fff2f0",
                                      padding: "6px 14px",
                                      borderRadius: 7
                                    }}>
                                      {item.oldUsername}
                                    </span>
                                    <span style={{ color: "#6c757d", fontSize: 20, fontWeight: 700 }}>→</span>
                                    <span style={{
                                      color: "#52c41a",
                                      fontWeight: 700,
                                      background: "#f6ffed",
                                      padding: "6px 14px",
                                      borderRadius: 7
                                    }}>
                                      {item.newUsername}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </section>
            </div>
          )}

          {/* --- Video Wallet Section --- */}
          {showVideoWallet && (
            <div className="container" style={{ padding: 0 }}>
              <section className="content">
                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                  <div className="col-md-10 col-12" style={{ background: "#fff", borderRadius: 12, padding: 30, boxShadow: "0 4px 18px #6f42c10a", marginBottom: 40 }}>

                    {/* Header */}
                    <div style={{ fontSize: 24, fontWeight: 700, color: "#6f42c1", marginBottom: 24, display: "flex", alignItems: "center", gap: 12 }}>
                      <i className="fa fa-wallet"></i>
                      Video Wallet Profile
                    </div>

                    {vwProfileLoading ? (
                      <div style={{ textAlign: "center", padding: 40 }}>
                        <i className="fa fa-spinner fa-spin" style={{ fontSize: 36, color: "#6f42c1" }}></i>
                      </div>
                    ) : !vwProfile ? (
                      <div style={{ textAlign: "center", padding: 40, color: "#888" }}>No wallet data found.</div>
                    ) : (
                      <>
                        {/* Balance + Watch Time row */}
                        <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 24 }}>
                          {[
                            { label: "M-Coins Balance", value: parseFloat(vwProfile.mcoinsBalance).toFixed(3), icon: "fa-coins", color: "#f5a623" },
                            { label: "Total Earned", value: parseFloat(vwProfile.totalEarned).toFixed(3), icon: "fa-trophy", color: "#52c41a" },
                            { label: "Watch Time (min)", value: vwProfile.watchTimeMinutes, icon: "fa-eye", color: "#1677ff" },
                            { label: "Watch Eligible", value: vwProfile.watchEligible ? "✅ Yes" : "❌ No", icon: "fa-check-circle", color: vwProfile.watchEligible ? "#52c41a" : "#ff4d4f" },
                          ].map(({ label, value, icon, color }) => (
                            <div key={label} style={{ flex: "1 1 180px", background: "#f8f0ff", borderRadius: 10, padding: "16px 20px", display: "flex", flexDirection: "column", gap: 6 }}>
                              <div style={{ fontSize: 13, color: "#888", display: "flex", alignItems: "center", gap: 6 }}>
                                <i className={`fa ${icon}`} style={{ color }}></i> {label}
                              </div>
                              <div style={{ fontSize: 22, fontWeight: 700, color }}>{value}</div>
                            </div>
                          ))}
                        </div>

                        {/* Day picker for activity */}
                        <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 16, flexWrap: "wrap" }}>
                          <div style={{ fontSize: 16, fontWeight: 600, color: "#444" }}>Activity for</div>
                          <DatePicker
  selected={
    vwProfileDay
      ? new Date(vwProfileDay + "T00:00:00+05:30")
      : null
  }
  onChange={(date) => {
    if (date) {
      // Force IST format YYYY-MM-DD
      const istDate = new Date(
        date.getTime() + (5.5 * 60 * 60 * 1000) - date.getTimezoneOffset() * 60000
      )
        .toISOString()
        .split("T")[0];

      setVwProfileDay(istDate);
      fetchVideoWalletProfile(istDate);
    }
  }}
  dateFormat="yyyy-MM-dd"
  maxDate={new Date()}
  className="form-control"
  style={{
    padding: "6px 12px",
    borderRadius: 8,
    border: "1.5px solid #6f42c1",
    color: "#6f42c1",
    fontWeight: 600,
    fontSize: 14
  }}
/>
                          <span style={{ fontSize: 13, color: "#aaa" }}>({vwProfile.today})</span>
                          {vwProfileLoading && <i className="fa fa-spinner fa-spin" style={{ color: "#6f42c1" }}></i>}
                        </div>
                        <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 20 }}>
                          {[
                            { label: "Likes", count: vwProfile.likeCount, threshold: vwProfile.likeThreshold, amount: vwProfile.likeAmount, collected: vwProfile.likeCollected, collectable: vwProfile.likeCollectable, color: "#eb2f96" },
                            { label: "Shares", count: vwProfile.shareCount, threshold: vwProfile.shareThreshold, amount: vwProfile.shareAmount, collected: vwProfile.shareCollected, collectable: vwProfile.shareCollectable, color: "#13c2c2" },
                          ].map(({ label, count, threshold, amount, collected, collectable, color }) => (
                            <div key={label} style={{ flex: "1 1 200px", background: "#fafafa", border: `1.5px solid ${color}22`, borderRadius: 10, padding: "16px 20px" }}>
                              <div style={{ fontSize: 15, fontWeight: 600, color, marginBottom: 8 }}>{label}</div>
                              <div style={{ fontSize: 13, color: "#555", marginBottom: 4 }}>
                                Count: <b>{count}</b> / {threshold} (earn {amount} M-Coins)
                              </div>
                              <div style={{ marginTop: 6 }}>
                                {collected ? (
                                  <span style={{ background: "#52c41a22", color: "#52c41a", borderRadius: 20, padding: "3px 12px", fontSize: 12, fontWeight: 600 }}>✅ Collected</span>
                                ) : collectable ? (
                                  <span style={{ background: "#f5a62322", color: "#d48806", borderRadius: 20, padding: "3px 12px", fontSize: 12, fontWeight: 600 }}>🟡 Ready to Collect</span>
                                ) : (
                                  <span style={{ background: "#ff4d4f22", color: "#ff4d4f", borderRadius: 20, padding: "3px 12px", fontSize: 12, fontWeight: 600 }}>🔴 Not Yet</span>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>

                        {/* Views: tracked per calendar month, not per day, so shown separately from the day picker above */}
                        <div style={{ fontSize: 14, fontWeight: 600, color: "#444", marginBottom: 10 }}>
                          Views {vwProfile.currentMonth ? `(${vwProfile.currentMonth})` : ""}
                        </div>
                        <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 28 }}>
                          <div style={{ flex: "1 1 200px", background: "#fafafa", border: "1.5px solid #1677ff22", borderRadius: 10, padding: "16px 20px" }}>
                            <div style={{ fontSize: 15, fontWeight: 600, color: "#1677ff", marginBottom: 8 }}>Views (This Month)</div>
                            <div style={{ fontSize: 13, color: "#555", marginBottom: 4 }}>
                              Count: <b>{vwProfile.viewCount}</b> / {vwProfile.viewThreshold} (earn {vwProfile.viewAmount} M-Coins)
                            </div>
                            <div style={{ marginTop: 6 }}>
                              {vwProfile.viewCollected ? (
                                <span style={{ background: "#52c41a22", color: "#52c41a", borderRadius: 20, padding: "3px 12px", fontSize: 12, fontWeight: 600 }}>✅ Collected</span>
                              ) : vwProfile.viewCollectable ? (
                                <span style={{ background: "#f5a62322", color: "#d48806", borderRadius: 20, padding: "3px 12px", fontSize: 12, fontWeight: 600 }}>🟡 Ready to Collect</span>
                              ) : (
                                <span style={{ background: "#ff4d4f22", color: "#ff4d4f", borderRadius: 20, padding: "3px 12px", fontSize: 12, fontWeight: 600 }}>🔴 Not Yet</span>
                              )}
                            </div>
                          </div>
                          <div style={{ flex: "1 1 200px", background: "#fafafa", border: "1.5px solid #722ed122", borderRadius: 10, padding: "16px 20px" }}>
                            <div style={{ fontSize: 15, fontWeight: 600, color: "#722ed1", marginBottom: 8 }}>Total Views Earned</div>
                            <div style={{ fontSize: 22, fontWeight: 700, color: "#722ed1" }}>{vwProfile.totalViews ?? 0}</div>
                            <div style={{ fontSize: 12, color: "#999", marginTop: 4 }}>All-time, across every month</div>
                          </div>
                        </div>
                      </>
                    )}

                    {/* History */}
                    <div style={{ fontSize: 20, fontWeight: 700, color: "#6f42c1", margin: "10px 0 16px 0", display: "flex", alignItems: "center", gap: 10 }}>
                      <i className="fa fa-history"></i> Collection History
                    </div>

                    {/* Type filter */}
                    <div style={{ display: "flex", gap: 10, marginBottom: 16 }}>
                      {["", "like", "share", "view"].map((t) => (
                        <button key={t} type="button"
                          onClick={() => { setVwTypeFilter(t); fetchVideoWalletHistory(1, t); }}
                          style={{ padding: "6px 18px", borderRadius: 20, border: "1.5px solid #6f42c1", background: vwTypeFilter === t ? "#6f42c1" : "#fff", color: vwTypeFilter === t ? "#fff" : "#6f42c1", fontWeight: 600, cursor: "pointer", fontSize: 13 }}>
                          {t === "" ? "All" : t.charAt(0).toUpperCase() + t.slice(1)}
                        </button>
                      ))}
                    </div>

                    {vwHistoryLoading ? (
                      <div style={{ textAlign: "center", padding: 30 }}>
                        <i className="fa fa-spinner fa-spin" style={{ fontSize: 30, color: "#6f42c1" }}></i>
                      </div>
                    ) : vwHistory.length === 0 ? (
                      <div style={{ textAlign: "center", padding: 30, color: "#888" }}>No collection history found.</div>
                    ) : (
                      <>
                        <table style={{ ...pageStyles.table, marginBottom: 0 }}>
                          <thead>
                            <tr>
                              {["#", "Day", "Type", "M-Coins Awarded", "Via", "Collected At"].map((h) => (
                                <th key={h} style={pageStyles.th}>{h}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {vwHistory.map((item, idx) => (
                              <tr key={item._id} style={idx % 2 === 0 ? pageStyles.evenRow : pageStyles.oddRow}>
                                <td style={pageStyles.td}>{(vwPage - 1) * 15 + idx + 1}</td>
                                <td style={pageStyles.td}>{item.day}</td>
                                <td style={pageStyles.td}>
                                  <span style={{ background: item.type === "like" ? "#eb2f9622" : item.type === "share" ? "#13c2c222" : "#1677ff22", color: item.type === "like" ? "#eb2f96" : item.type === "share" ? "#13c2c2" : "#1677ff", borderRadius: 20, padding: "3px 12px", fontWeight: 600, fontSize: 13 }}>
                                    {item.type}
                                  </span>
                                </td>
                                <td style={{ ...pageStyles.td, color: "#52c41a", fontWeight: 700 }}>+{item.mcoinsAwarded}</td>
                                <td style={pageStyles.td}>{item.via}</td>
                                <td style={pageStyles.td}>{item.collectedAt ? new Date(item.collectedAt).toLocaleString() : "-"}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 14 }}>
                          <button style={pageStyles.btnSecondary} disabled={vwPage <= 1}
                            onClick={() => { const p = vwPage - 1; fetchVideoWalletHistory(p, vwTypeFilter); }}>Prev</button>
                          <span style={{ alignSelf: "center", color: "#888", fontSize: 13 }}>{vwPage} / {vwTotalPages}</span>
                          <button style={pageStyles.btnSecondary} disabled={vwPage >= vwTotalPages}
                            onClick={() => { const p = vwPage + 1; fetchVideoWalletHistory(p, vwTypeFilter); }}>Next</button>
                        </div>
                      </>
                    )}

                  </div>
                </div>
              </section>
            </div>
          )}

          {/* --- IP History Section --- */}
          {showIpHistory && (
            <div className="container" style={{ padding: 0 }}>
              <section className="content">
                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                  <div className="col-md-10 col-12" style={{
                    background: "#fff",
                    borderRadius: 12,
                    padding: 30,
                    boxShadow: "0 4px 18px #1677ff0a",
                    marginBottom: 40
                  }}>
                    <div style={{
                      fontSize: 24,
                      fontWeight: 700,
                      color: "#0ea5e9",
                      marginBottom: 20,
                      display: "flex",
                      alignItems: "center",
                      gap: 12
                    }}>
                      <i className="fa fa-map-marker"></i>
                      IP & Location History
                    </div>

                    {ipHistoryLoading ? (
                      <div style={{ textAlign: "center", padding: 50 }}>
                        <i className="fa fa-spinner fa-spin" style={{ fontSize: 40, color: "#0ea5e9" }}></i>
                        <div style={{ marginTop: 10, color: "#888" }}>Loading IP history...</div>
                      </div>
                    ) : !ipHistory || ipHistory.length === 0 ? (
                      <div style={{ textAlign: "center", padding: 50, color: "#888", fontSize: 16 }}>
                        <i className="fa fa-info-circle" style={{ fontSize: 30, marginBottom: 10 }}></i>
                        <div>No IP history recorded for this user.</div>
                      </div>
                    ) : (
                      <table style={pageStyles.table}>
                        <thead>
                          <tr>
                            <th style={pageStyles.th}>Sr.</th>
                            <th style={pageStyles.th}>IP Address</th>
                            <th style={pageStyles.th}>Location</th>
                            <th style={pageStyles.th}>Login Method</th>
                            <th style={pageStyles.th}>Device ID</th>
                            <th style={pageStyles.th}>Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ipHistory.map((item, index) => (
                            <tr key={item._id}>
                              <td style={pageStyles.td}>{index + 1}</td>
                              <td style={pageStyles.td}>{item.ip || "-"}</td>
                              <td style={pageStyles.td}>
                                {[item.location?.city, item.location?.region, item.location?.country]
                                  .filter(Boolean)
                                  .join(", ") || "-"}
                              </td>
                              <td style={pageStyles.td}>
                                <span style={{
                                  textTransform: "capitalize",
                                  background: "#eef2ff",
                                  color: "#4338ca",
                                  padding: "4px 10px",
                                  borderRadius: 6,
                                  fontSize: 13,
                                  fontWeight: 600
                                }}>
                                  {item.loginMethod || "-"}
                                </span>
                              </td>
                              <td style={pageStyles.td}>{item.deviceId || "-"}</td>
                              <td style={pageStyles.td}>{formatDate(item.createdAt)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </section>
            </div>
          )}

          {/* --- Transactions Table --- */}
          {!showUsernameHistory && !showVideoWallet && !showIpHistory && (
          <div className="container" style={{ padding: 0 }}>
            <section className="content">
              <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                <div className="col-md-10 col-12">
                  <table style={pageStyles.table}>
                    <thead>
                      <tr>
                        <th style={pageStyles.th}>Sr.</th>
                        {type === 100 ? (
                          <>
                            <th style={pageStyles.th}>Stars</th>
                            <th style={pageStyles.th}>M-Coins</th>
                            <th style={pageStyles.th}>Available Stars</th>
                            <th style={pageStyles.th}>Available M-coins</th>
                            <th style={pageStyles.th}>Date</th>
                          </>
                        ) : (
                          <>
                            <th style={pageStyles.th}>Amount</th>
                            <th style={pageStyles.th}>Other</th>
                            <th style={pageStyles.th}>Available Balance</th>
                            <th style={pageStyles.th}>Comment</th>
                            <th style={pageStyles.th}>Date</th>
                          </>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {coinH.length === 0 ? (
                        <tr>
                          <td colSpan={6} style={{ ...pageStyles.td, textAlign: "center" }}>
                            No Data
                          </td>
                        </tr>
                      ) : (
                        coinH.map((item, index) => (
                          <tr key={index} style={index % 2 === 0 ? pageStyles.evenRow : pageStyles.oddRow}>
                            <td style={pageStyles.td}>{index + 1}</td>
                            {type === 100 ? (
                              <>
                                <td style={pageStyles.td}>{item.coins}</td>
                                <td style={pageStyles.td}>{item.recCoins}</td>
                                <td style={pageStyles.td}>{item.availableCoins}</td>
                                <td style={pageStyles.td}>{item.availableRecCoins}</td>
                                <td style={pageStyles.td}>{item.createdAt}</td>
                              </>
                            ) : (
                              <>
                                <td style={pageStyles.td}>
                                  {item.type === "0" ? (
                                    <>
                                      {sign.plus}
                                      {item.amount}
                                    </>
                                  ) : (
                                    <>
                                      {sign.minus}
                                      {item.amount}
                                    </>
                                  )}
                                </td>
                                <td style={pageStyles.td}>{item.other}</td>
                                <td style={pageStyles.td}>{item.availabeBalance}</td>
                                <td style={pageStyles.td}>{item.comment || "-"}</td>
                                <td style={pageStyles.td}>{item.createdAt}</td>
                              </>
                            )}
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, margin: "10px 10% 40px 0" }}>
                <button
                  style={pageStyles.btnSecondary}
                  onClick={async () => {
                    if (type === 100) {
                      setP(p - 1); await ConvertTransactions(p - 1); return;
                    }
                    if (sign.plus == "-") {
                      setP(p - 1); await CoinsTransaction(p - 1, type);
                    } else {
                      setP(p - 1); await RecCoinsTransaction(p - 1, type);
                    }
                  }}
                >Prev</button>
                <button
                  style={pageStyles.btnSecondary}
                  onClick={async () => {
                    if (type === 100) {
                      setP(p + 1); await ConvertTransactions(p + 1); return;
                    }
                    if (sign.plus == "-") {
                      setP(p + 1); await CoinsTransaction(p + 1, type);
                    } else {
                      setP(p + 1); await RecCoinsTransaction(p + 1, type);
                    }
                  }}
                >Next</button>
              </div>
            </section>
          </div>
          )}
        </>
      )}
    </>
  );
};

export default ViewUser;
